export default "__VITE_ASSET__4c4892be__"